import { render } from "./TheSuggestionsList.vue?vue&type=template&id=4c9ce11c&scoped=true"
import script from "./TheSuggestionsList.vue?vue&type=script&lang=js"
export * from "./TheSuggestionsList.vue?vue&type=script&lang=js"

import "./TheSuggestionsList.vue?vue&type=style&index=0&id=4c9ce11c&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4c9ce11c"

export default script